module.exports = __webpack_public_path__ + "static/fonts/BMDOHYEON_ttf.ttf?9dbe9ac8";